import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../shared/security/auth.service";
import {PsusService} from "../shared/model/psus.service";
import {CommandService} from "../shared/model/command.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-psu-factory-power',
  templateUrl: './psu-factory-power.component.html',
  styleUrls: ['./psu-factory-power.component.css']
})
export class PsuFactoryPowerComponent implements OnInit {
  @Input()
  clubId: string;

  @Input()
  fieldId: string;

  @Input()
  cpuId: string;

  @Input()
  psuId: number;

  @Input()
  currentFactoryPower: number;

  @Input()
  description: string;

  @Output()
  onFactoryPowerDone = new EventEmitter<boolean>();

  myForm: FormGroup;

  public booleanValues = [
    {value: true, display: 'Ja'},
    {value: false, display: 'Nee'}
  ];

  authInfo: AuthService;
  applyToField: boolean = false;         // apply maximum output power to whole field instead of just selected PSU
  soll: number;
  ist: number;

  isSaved: boolean = false;
  hasError: boolean = false;
  message: string = "";

  public visibleFactoryPower = true;
  private visibleFactoryPowerAnimate = false;

  constructor(private fb: FormBuilder, private psusService: PsusService, private commandService: CommandService,
              private authService: AuthService, private translate: TranslateService) {
    this.myForm = fb.group({
      'factoryPower': ['', Validators.compose([Validators.required, Validators.min(200), Validators.max(855)])],
    });
    this.authInfo = authService;
  }

  formDone(done: boolean) {
    //console.log("psu power on: formDone() pressed: " + done);
    this.onFactoryPowerDone.emit(false);  // hide modal add screen
  }

  toggleApplyToField() {
    this.applyToField = !this.applyToField;  // hide modal add screen
  }

  ngOnInit() {
    //console.log("ngOnInit: PsuDetailComponent");
    //console.log("dbPath ngOnInit(): ", this.dbPath);
    this.translate.get('l.yes')
      .subscribe((res: string) => {
        this.booleanValues[0].display = res;
      });
    this.translate.get('l.no')
      .subscribe((res: string) => {
        this.booleanValues[1].display = res;
      });

    this.isSaved = false;
    this.show();
  }

  public show(): void {
    this.visibleFactoryPower = true;
    setTimeout(() => this.visibleFactoryPowerAnimate = true);
  }

  public hide(): void {
    this.visibleFactoryPowerAnimate = false;
    setTimeout(() => this.visibleFactoryPower = false, 300);
  }

  public save() {
    this.translate.get('s.spawn')
      .subscribe((res: string) => {
        this.message = res;
        this.isSaved = true;
      });

    if(this.applyToField) {
      this.commandService.addCommand(this.clubId, this.fieldId, null, null, "SET_PWM", this.currentFactoryPower, false, this.fieldId, this.authService.getUserName());
    } else {
      this.commandService.addCommand(this.clubId, this.fieldId, this.cpuId, this.psuId, "SET_PWM", this.currentFactoryPower, false, this.fieldId, this.authService.getUserName());
    }
  }

  public isNewPsuType(): boolean {
    return this.description.startsWith('1');
  }


}
